import { useTranslation } from 'react-i18next'
import { dayById } from 'core/utils/date'
import { VpBadge, VpProgressBar } from '@vtmn-play/react'
import { daysArray } from './daily-board-utils'
import type { WeekIndicatorsValues } from 'core/api/home/weekly/useApiGetWeekIndicators'
import Weather from '../../weather'

interface DailyWeatherAndTargetProps {
  weeklyData: Record<number, WeekIndicatorsValues>
  isCurrentWeek: boolean
}

const getTargetPercent = (indicatorsValues: WeekIndicatorsValues | undefined): number => {
  if (indicatorsValues?.realized_gmv?.value == null || indicatorsValues?.forecast_gmv?.value == null) {
    return 0
  }
  if (indicatorsValues?.forecast_gmv?.value === 0) {
    return 100
  }

  const targetRatio = indicatorsValues?.realized_gmv?.value / indicatorsValues?.forecast_gmv?.value
  return Number.isFinite(targetRatio) ? Math.floor(targetRatio * 100) : 0
}

const DailyWeatherAndTarget = ({ weeklyData, isCurrentWeek }: DailyWeatherAndTargetProps) => {
  const { t } = useTranslation()
  const today = new Date().getDay() + 1

  return (
    <>
      {daysArray.map(day => {
        const targetPercent = getTargetPercent(weeklyData?.[day])
        const isToday = isCurrentWeek && day === today

        return (
          <div key={day} data-testid={`day-row-${day}`} className="mg-daily-board-row-day">
            <div className="mg-daily-board-day-weather">
              <div className="mg-daily-board-day-label vp-caption">
                {isToday ? <VpBadge>{t(dayById[day])}</VpBadge> : t(dayById[day])}
              </div>
              <Weather weatherCode={weeklyData?.[day]?.weather_code} iconPlaceholder="--" />
            </div>
            <VpProgressBar
              className={`mg-daily-board-target-progress${targetPercent >= 100 ? ' mg-daily-board-target-progress__success' : ''}`}
              value={targetPercent}
              variant="linear"
              key={`progress-${day}`}
            />
          </div>
        )
      })}
    </>
  )
}

export default DailyWeatherAndTarget
